/**
 * Section: testimonials
 *
 * Mobile: Swiper carousel with pagination dots.
 * Desktop: static row (Swiper destroyed at 1024px+).
 */
if (!customElements.get('testimonials-carousel')) {
  customElements.define(
    'testimonials-carousel',
    class TestimonialsCarousel extends HTMLElement {
      swiper = null;
      mql = window.matchMedia('(max-width: 1023px)');

      connectedCallback() {
        this.onMediaChange = this.onMediaChange.bind(this);
        this.mql.addEventListener('change', this.onMediaChange);

        if (this.mql.matches) {
          this.initSwiper();
        }
      }

      disconnectedCallback() {
        this.mql.removeEventListener('change', this.onMediaChange);
        this.destroySwiper();
      }

      onMediaChange(event) {
        if (event.matches) {
          this.initSwiper();
          return;
        }

        this.destroySwiper();
      }

      initSwiper() {
        if (!window.Swiper || this.swiper) {
          return;
        }

        const sectionId = this.dataset.sectionId;
        const carouselEl = this.querySelector(`#testimonials-swiper-${sectionId}`);

        if (!carouselEl) {
          return;
        }

        this.swiper = new window.Swiper(carouselEl, {
          slidesPerView: 1,
          spaceBetween: 0,
          pagination: {
            el: this.querySelector('.testimonials__pagination'),
            clickable: true,
          },
          watchOverflow: true,
        });
      }

      destroySwiper() {
        if (!this.swiper) {
          return;
        }

        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    },
  );
}
